// import types
import type { PlanGroup, PlanUnit } from 'components/types';

/** An option of the plan unit (planeenheid) multi-select: a plan unit, or a plan group of them. */
export type OrganizationalUnitOption = PlanUnit | PlanGroup;

/**
 * How a picked plan unit or group is remembered: its `uniqId` — a number for a plan unit, a string like
 * "5-group" for a plan group, since the two carry their own table's `id` and those collide.
 */
export type OrganizationalUnitId = OrganizationalUnitOption['uniqId'];

/**
 * The picked plan units as the cost-centre ids a request carries as `organizationalUnitIds: number[]`.
 *
 * A plan group contributes the plan units it holds rather than itself, and each is read by `brId` rather
 * than `uniqId`: `uniqId` on a group is a string like "5-group".
 */
export const organizationalUnitCostCenterIds = (
  organizationalUnits: OrganizationalUnitOption[]
): number[] =>
  organizationalUnits
    .flatMap((organizationalUnit) =>
      'costCenters' in organizationalUnit &&
      Array.isArray(organizationalUnit.costCenters)
        ? organizationalUnit.costCenters
        : [organizationalUnit]
    )
    .map((organizationalUnit) =>
      'brId' in organizationalUnit &&
      typeof organizationalUnit.brId === 'number'
        ? organizationalUnit.brId
        : organizationalUnit.id
    )
    .filter((id): id is number => typeof id === 'number');
